import pressImageUrls from '../../common/models/pressImageUrls';
import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../Wrapper/Wrapper';
import PressImagesContainer from './PressImagesContainer';

const PressImages = ({ isDesktop, s3BasePath }) => (
  <PressImagesContainer isDesktop={isDesktop}>
    {pressImageUrls.map(img => (
      <Wrapper height="auto" width="32%" textAlign="center" key={img.url}>
        <img style={{ width: img.width, marginTop: '15px' }} src={`${s3BasePath}${img.url}`} />
      </Wrapper>
    ))}
  </PressImagesContainer>
);

PressImages.defaultProps = {
  isDesktop: false
};

PressImages.propTypes = {
  isDesktop: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired
};

export default PressImages;
